<div class="flex h-full min-h-0 w-full gap-4">
  @if (initialTableRowsByKeyResource.hasValue()) {
    <ct-extraction-data-capturing-position-type
      class="flex-1"
      [formArrayCacheKey]="`${currentDocument().id}-${tableModel().key}`"
      [capturingConfig]="{
        document: currentDocument(),
        tableModel: tableModel(),
      }"
      [initialRows]="initialTableRowsByKeyResource.value()?.[tableModel().key] ?? []"
      (tableValueChange)="saveTableValues(tableModel().key, $event)"
      (continue)="continue.emit()" />
  }
</div>
